<template>
  <div class="polymerizationDataMain">
      <div class="btn-tools">
        <el-button @click="addTableColumn" type="primary">新增表头</el-button>
        <el-button @click="delTableColumn"  type="danger">删除表头</el-button>
        <el-button @click="addRefTableData" type="primary">新增映射数据</el-button>  
        <el-button @click="saveReportTableData" type="primary">保存配置</el-button>      
      </div>
      <div class="report-table-box">
            <el-table
              :data="tableData"
              border
              style="width: 100%">
                  <el-table-column
                      v-for="(column, index) in tableColumns"
                        :key="index"
                        :prop="column.prop"
                        :label="column.label"
                        width="280">
                    <template slot-scope="scope">
                      <!-- <el-input type="text" v-model="scope.row[column.prop]"></el-input> -->
                      <el-select  v-model="scope.row[column.prop]">
                          <el-option
                            v-for="item in reportTableColumns"
                            :key="item.prop"
                            :label="item.label"
                            :value="item.prop">
                          </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="120"
                    v-if="tableColumns.length>0"
                    >
                    <template slot-scope="scope">
                        <el-button
                        @click.native.prevent="deleteRow(scope.$index)"
                        type="text"
                        size="small">
                        移除
                        </el-button>
                    </template>
                    </el-table-column>
            </el-table>
      </div>
      <el-dialog
        title="删除表头"
        :visible.sync="showDelTableHead"
        append-to-body
        width="30%"
        >
        <span>
          <el-tag
            v-for="tag in tableColumns"
            :key="tag.id"
            closable
            type="danger"
            @close="handleClose(tag)">
            {{tag.label}}
          </el-tag>
        </span>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span> -->
      </el-dialog>
  </div>
</template>
<script>
import Table from '../Table/Table.vue';
export default {
    components: { Table },
    data () {
        return {
            tableData: [],
            tableColumns: [],
            showDelTableHead: false
        };
    },
    props: {
        reportTableColumns: {
            type: Array
        },
        reportData: {
            type: Object
        }

    },
    created () {
        // console.log(this.reportData);
        // console.log(this.reportTableColumns);
        if (this.reportData.aggregateReprotTableData) { // 修改进行赋值
            this.tableData = this.reportData.aggregateReprotTableData.tableData;
            this.tableColumns = this.reportData.aggregateReprotTableData.tableColumns;
        }
    },
    methods: {
        deleteRow (index) {
            this.tableData.splice(index, 1);
        },
        addTableColumn () {
            this.$prompt('请输入表头', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(({ value }) => {
                let cacheId = this.generateUUID();
                let item = {
                    id: cacheId,
                    prop: cacheId,
                    label: value
                };
                this.tableColumns.push(item);
            });
        },
        delTableColumn () {
            this.showDelTableHead = true;
        },
        handleClose (tag) {
            for (let i = 0; i < this.tableColumns.length; i++) {
                let cur = this.tableColumns[i];
                if (cur.id === tag.id) {
                    this.tableColumns.splice(i, 1);
                }
            }
        },
        addRefTableData () {
            let item = {};
            for (let i = 0; i < this.tableColumns.length; i++) {
                let cur = this.tableColumns[i];
                item[cur.id] = '';
            }
            item.id = this.generateUUID();
            this.tableData.push(item);
        },
        generateUUID () {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === 'function') {
                d += window.performance.now(); // use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid.replace(RegExp('-', 'g'), '');
        },
        saveReportTableData () {
            let jsonObj = {tableColumns: this.tableColumns, tableData: this.tableData};
            this.$emit('saveReportTableData', jsonObj);
        }
    }
};
</script>
<style scoped lang="less">
    .polymerizationDataMain{
        width: 80vw;
        height: 80vh;
        .btn-tools{
            height: 36px;
            line-height: 36px;
            text-align: right;
        }
        .report-table-box{
            margin-top: 14px;
            width: 78vw;
            overflow: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/CustomReportConfig/PolymerizationData.vue